import React from "react";

const CustomFilterTopInfo = ({ label, value }) => {
  return (
    <button
      style={{
        backgroundColor: "#000",
        color: "#fff",
        padding: "8px 16px",
        border: "none",
        borderRadius: "6px",
        cursor: "pointer",
      }}
      disabled>
      {label}: {value}
    </button>
  );
};

export default CustomFilterTopInfo;
